/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    array, bool, func, object, string,
} from 'prop-types';

import { Grid, makeStyles } from '@material-ui/core';

import { format } from 'date-fns';
import { calendarColorStyle } from '../Helpers/Style-Helper';

import EnterpriseCalendarHeader from './partials/CalendarHeader/EnterpriseCalendarHeader';
import EnterpriseCalendarFooter from './partials/EnterpriseCalendarFooter/EnterpriseCalendarFooter';
import MonthDaysCalendar from './partials/TypeCalendars/MonthDaysCalendar';
import MonthlyWeeklyCalendar from './partials/TypeCalendars/MonthlyWeeklyCalendar';
import MonthNavegation from './partials/MonthNavegation/MonthNavegation';

import { getFeatureFlags } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import {
    convertDateObjToStrDate, convertDateStringToObj,
    formatDateDDMMYYToYYYYMMDD, getBannerDataFromCMS,
    getDateStrBtn, getHolidayDeliveryDate, getListDeliveryDates,
    getListHolidayDates,
} from './helpers/Calendar-Helper';
import CalendarBanner from './partials/CalendarBanner/CalendarBanner';
import SaveDateButton from './partials/SaveDateButton/SaveDateButton';
import { calendarMapPresentation } from '../Helpers/Sku-helper';

const useStyles = makeStyles(
    () => ({
        root: {
            margin: 0,
            color: calendarColorStyle.primary.main,
        },
    }),
    { name: 'EnterpriseCalendar' },
);

const EnterpriseCalendar = ({
    calendarData,
    calendarListByDates,
    cmsData,
    forceExactDay,
    handleDeliveryCalendarClose,
    holidaySelected,
    isOpenCalendarConsent,
    orderItem,
    holidayDateCollection,
    pageType,
    recipientItem,
    selectedDate,
    selectedDeliveryDateObj,
    selectedHoliday,
    setCalendarSelectionChanged,
    setForceExactDay,
    setHolidaySelected,
    setSelectedDate,
    setSelectedDateRange,
    setSelectedDeliveryDateObj,
    setSelectedHoliday,
    setStartDateCalendar,
    shipHolidayDetails,
    startDateCalendar,
    selectedDateRange,
}) => {
    const classes = useStyles();
    const featureFlags = useSelector(getFeatureFlags);

    const [flexOptionSelected, setFlexOptionSelected] = useState({});

    const bannerData = getBannerDataFromCMS(selectedDate, cmsData, featureFlags['is-calendar-holiday-banner-enabled']);
    const calendarPresentationFamily = calendarMapPresentation[orderItem?.product?.brandCode || '1001'] || 'flower';

    const handleSetSelectedDateDetails = (selDateDetailsProps, dateObj, userClickCalendar) => {
        const selDateProps = selDateDetailsProps?.[0] || {};
        selDateProps.dateObj = dateObj;
        let selectedDateRangeInfo = [];

        let updateforceExactDay = forceExactDay;
        if (userClickCalendar) {
            updateforceExactDay = false;
        } else if (orderItem.deliveryInfo?.deliveryDateType === 'on' && selDateProps.calendarDateType === 'between') {
            updateforceExactDay = true;
        }

        if (selDateProps.calendarDateType === 'between' && (!updateforceExactDay || userClickCalendar)) {
            const deliveryDate = convertDateStringToObj(selDateProps.deliveryDate);
            let rangeStartDate = convertDateStringToObj(selDateProps.rangeStartDate);

            if (selDateProps.holidayStartDate) {
                rangeStartDate = convertDateStringToObj(selDateProps.holidayStartDate);
            }
            selectedDateRangeInfo = getDateStrBtn(rangeStartDate, deliveryDate).map((date) => (
                convertDateObjToStrDate(date)
            ));
        } else {
            selectedDateRangeInfo.push(selDateProps.deliveryDate);
        }

        if (Object.prototype.hasOwnProperty.call(calendarData, 'guaranteedCharge')) {
            selDateProps.guaranteedChargeToApply = calendarData.guaranteedCharge;
        }

        if (selDateProps.deliveryDate && selectedDate && selDateProps.deliveryDate !== selectedDate) {
            setCalendarSelectionChanged(true);
        }

        // // Select the current flex if cart have any already
        // if (selDateProps.flexDetails?.option) {
        //     let flexSelectedByCalendar = selDateProps.flexDetails.option.find((flexDate) => flexDate?.defaultOption === 'Y') || null;
        //     const deliveryDateFromCart = new Date(orderItem.deliveryInfo.deliveryDate);
        //     const deliveryDateFromCartStr = convertDateObjToStrDate(deliveryDateFromCart);

        //     if (orderItem.selectedFlexOption?.optionCode && selDateProps.deliveryDate === deliveryDateFromCartStr) {
        //         flexSelectedByCalendar = selDateProps.flexDetails.option.find((flexDate) => flexDate?.optionCode === orderItem.selectedFlexOption.optionCode) || null;
        //     }

        //     if (flexSelectedByCalendar) {
        //         setFlexOptionSelected(flexSelectedByCalendar);
        //     }
        // }

        setSelectedDate(selDateProps.deliveryDate);
        setSelectedDateRange(selectedDateRangeInfo);
        setSelectedDeliveryDateObj(selDateProps);
        setForceExactDay(updateforceExactDay);
    };

    useEffect(() => {
        if (calendarData.calendarDates) {
            const calendarDatesFromCalendar = calendarData.calendarDates;
            const calendarListByDatesObj = getListDeliveryDates(calendarDatesFromCalendar);
            const deliveryDateFromCart = new Date(orderItem.deliveryInfo.deliveryDate);
            let deliveryDateFromCartStr = convertDateObjToStrDate(deliveryDateFromCart);

            if (orderItem.selectedFlexOption?.calendarDate) {
                const flexFormatedDateYYYYMMDD = formatDateDDMMYYToYYYYMMDD(orderItem.selectedFlexOption.calendarDate);
                if (flexFormatedDateYYYYMMDD !== deliveryDateFromCartStr) {
                    deliveryDateFromCartStr = flexFormatedDateYYYYMMDD;
                }
            }

            let currentDateInfoFromCalendar = calendarListByDatesObj[deliveryDateFromCartStr];

            if (calendarData.deliveryIndicator === 'MO' && orderItem.deliveryInfo.deliveryDate.includes('/')) {
                const deliveryMonthDate = new Date(orderItem.deliveryInfo.deliveryDate);
                const endOfMonthCalendar = new Date(deliveryMonthDate.getFullYear(), deliveryMonthDate.getMonth() + 1, 0);
                const formattedEndMonthDate = format(endOfMonthCalendar, 'MM/dd/yyyy');
                currentDateInfoFromCalendar = calendarListByDatesObj[formattedEndMonthDate];
            } else if (calendarData.deliveryIndicator === 'WO' && orderItem.deliveryInfo.deliveryDate.includes('/')) {
                const deliveryMonthDate = orderItem.deliveryInfo.deliveryDate.split(' ')?.[0];
                currentDateInfoFromCalendar = calendarListByDatesObj[deliveryMonthDate];
            }

            let selectedDateValue = selectedDate || deliveryDateFromCartStr;
            let selectHolidayCode = 'Holiday Delivery';
            const shipHolidays = calendarData.shipHolidays || [];
            const collectionOfHolidayByHolidayCode = getListHolidayDates(shipHolidays);

            if (
                !selectedHoliday?.holidayDate
                && Object.keys(collectionOfHolidayByHolidayCode).length > 0) {
                if (orderItem?.deliveryInfo?.holidayCode) {
                    selectHolidayCode = orderItem?.deliveryInfo?.holidayCode;
                } else if (selectedDeliveryDateObj.holidayCode?.[0]) {
                    selectHolidayCode = selectedDeliveryDateObj.holidayCode[0];
                }
            }

            if (selectedHoliday?.holidayDate) {
                selectHolidayCode = selectedHoliday?.holidayCode;
                selectedDateValue = getHolidayDeliveryDate(selectHolidayCode, calendarData.calendarDates);
                const holidayDetails = collectionOfHolidayByHolidayCode[selectHolidayCode];
                // When the holiday dont have the complete information in the ship holiday
                // we search the information in the calendar.
                if (!selectedHoliday.holidayStartDate) {
                    if (holidayDetails?.[0]?.holidayStartDate) {
                        const holidayStartDate = convertDateStringToObj(holidayDetails[0].holidayStartDate);
                        const holidayDeliveryDate = convertDateStringToObj(holidayDetails[0].holidayDate);

                        const holidaySelectedDateRangeInfo = getDateStrBtn(holidayStartDate, holidayDeliveryDate).map((date) => (
                            convertDateObjToStrDate(date)
                        ));
                        setSelectedDateRange(holidaySelectedDateRangeInfo);

                        const currentListByDates = getListDeliveryDates(calendarData.calendarDates);
                        if (holidayDetails[0].holidayDate && currentListByDates[holidayDetails[0].holidayDate]) {
                            setSelectedDeliveryDateObj(currentListByDates[holidayDetails[0].holidayDate][0]);
                        }
                    }
                }
            }

            if (currentDateInfoFromCalendar && !selectedDeliveryDateObj.deliveryDate) {
                if (typeof selectedDateValue === 'string') {
                    selectedDateValue = convertDateStringToObj(selectedDateValue);
                }
                handleSetSelectedDateDetails(currentDateInfoFromCalendar, selectedDateValue);
            }

            setSelectedDate(selectedDateValue);
            setHolidaySelected(selectHolidayCode);
        }
    }, [calendarData]);

    return (
        <Grid container className={classes.root}>
            {
                calendarPresentationFamily !== 'flower' && (
                    <EnterpriseCalendarHeader
                        calendarData={calendarData}
                        calendarListByDates={calendarListByDates}
                        forceExactDay={forceExactDay}
                        handleSetSelectedDateDetails={handleSetSelectedDateDetails}
                        holidayDateCollection={holidayDateCollection}
                        holidaySelected={holidaySelected}
                        selectedDeliveryDateObj={selectedDeliveryDateObj}
                        selectedDateRange={selectedDateRange}
                        setForceExactDay={setForceExactDay}
                        setHolidaySelected={setHolidaySelected}
                        setSelectedDeliveryDateObj={setSelectedDeliveryDateObj}
                        setSelectedDateRange={setSelectedDateRange}
                        setStartDateCalendar={setStartDateCalendar}
                        setSelectedHoliday={setSelectedHoliday}
                        shipHolidayDetails={shipHolidayDetails}
                        startDateCalendar={startDateCalendar}
                    />
                )
            }
            {
                bannerData.isBannerEnabled
                && <CalendarBanner bannerData={bannerData} />
            }
            {
                !['WO', 'MO'].includes(calendarData?.deliveryIndicator)
                && calendarData.calendarDates?.length > 0
                && (
                    <MonthNavegation
                        calendarData={calendarData}
                        orderItem={orderItem}
                        recipientItem={recipientItem}
                        startDateCalendar={startDateCalendar}
                        setStartDateCalendar={setStartDateCalendar}
                    />
                )
            }
            <Grid item xs={12}>
                {
                    ['WO', 'MO'].includes(calendarData?.deliveryIndicator)
                        ? (
                            <MonthlyWeeklyCalendar
                                calendarData={calendarData}
                                calendarListByDates={calendarListByDates}
                                handleSetSelectedDateDetails={handleSetSelectedDateDetails}
                                selectedDate={selectedDate}
                                setSelectedDate={setSelectedDate}
                            />
                        )
                        : (
                            <MonthDaysCalendar
                                bannerData={bannerData}
                                calendarData={calendarData}
                                calendarListByDates={calendarListByDates}
                                cmsData={cmsData}
                                handleSetSelectedDateDetails={handleSetSelectedDateDetails}
                                holidayDateCollection={holidayDateCollection}
                                isHolidayBannerEnabled={featureFlags['is-calendar-holiday-banner-enabled']}
                                orderItem={orderItem}
                                selectedDateRange={selectedDateRange}
                                setForceExactDay={setForceExactDay}
                                setHolidaySelected={setHolidaySelected}
                                setSelectedHoliday={setSelectedHoliday}
                                startDateCalendar={startDateCalendar}
                            />
                        )
                }
            </Grid>
            {
                calendarData?.calendarDates?.length > 0
                || ['WO', 'MO'].includes(calendarData?.deliveryIndicator)
                    ? (
                        <EnterpriseCalendarFooter
                            calendarData={calendarData}
                            cmsData={cmsData}
                            flexOptionSelected={flexOptionSelected}
                            forceExactDay={forceExactDay}
                            orderItem={orderItem}
                            selectedDeliveryDateObj={selectedDeliveryDateObj}
                            selectedHoliday={selectedHoliday}
                            setFlexOptionSelected={setFlexOptionSelected}
                            shipHolidayDetails={shipHolidayDetails}
                        />
                    ) : null
            }
            {
                calendarData?.calendarDates?.length > 0
                || ['WO', 'MO'].includes(calendarData?.deliveryIndicator)
                    ? (
                        <SaveDateButton
                            calendarData={calendarData}
                            flexOptionSelected={flexOptionSelected}
                            forceExactDay={forceExactDay}
                            handleDeliveryCalendarClose={handleDeliveryCalendarClose}
                            holidaySelected={holidaySelected}
                            isOpenCalendarConsent={isOpenCalendarConsent}
                            orderItem={orderItem}
                            pageType={pageType}
                            selectedDeliveryDateObj={selectedDeliveryDateObj}
                        />
                    ) : null
            }
        </Grid>
    );
};

EnterpriseCalendar.propTypes = {
    calendarData: object,
    calendarListByDates: object.isRequired,
    cmsData: object,
    forceExactDay: bool.isRequired,
    handleDeliveryCalendarClose: func.isRequired,
    holidaySelected: string.isRequired,
    isOpenCalendarConsent: bool.isRequired,
    orderItem: object.isRequired,
    holidayDateCollection: array.isRequired,
    pageType: string.isRequired,
    recipientItem: object.isRequired,
    selectedDate: string.isRequired,
    selectedDeliveryDateObj: object.isRequired,
    selectedHoliday: object.isRequired,
    setCalendarSelectionChanged: func.isRequired,
    setForceExactDay: func.isRequired,
    setHolidaySelected: func.isRequired,
    setSelectedDate: func.isRequired,
    setSelectedDateRange: func.isRequired,
    setSelectedDeliveryDateObj: func.isRequired,
    setSelectedHoliday: func.isRequired,
    setStartDateCalendar: func.isRequired,
    shipHolidayDetails: object.isRequired,
    startDateCalendar: string.isRequired,
    selectedDateRange: array.isRequired,
};

EnterpriseCalendar.defaultProps = {
    calendarData: {},
    cmsData: {},
};

export default EnterpriseCalendar;
